function modifyEndDate(searchFilters) {
  searchFilters.config.forEach(searchFilter => {
    if (searchFilter.type === 'OrFilter') {
      searchFilter.config.forEach(filter => {
        if (
          filter.type === 'DateRangeFilter' &&
          filter.field_name === 'acquired'
        ) {
          filter.config.lte = new Date().toISOString();
        }
      });
    }
  });
  return searchFilters;
}

export default modifyEndDate;
